import React, {Component} from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import {Config} from 'app.config';
import {routes} from "helpers/routes";
import {TimeProvider} from "helpers/time";
import {TokenRefresher} from "helpers/login";

import Conversations from 'containers/Conversations';
import Login from 'containers/Login';
import Registration from 'containers/Registration';
import ForgottenPassword from 'containers/ForgottenPassword';
import Statistics from 'containers/Stats';
import Catalogue from 'containers/Catalogue';
import PrerecordedMessages from 'containers/PrerecordedMessages';

import PageNotFound from "containers/Error/PageNotFound";
import DataProvider from 'containers/DataProvider';
import Settings from 'containers/Settings';
import InitialAdvertCreator from 'containers/InitialAdvertCreator';

import {generateUrl} from "./helpers/routes";


class App extends Component {
    render() {
        const basename = Config.basename || "";
        return (
            <TimeProvider>
                <TokenRefresher>
                    <Router basename={basename}>
                        <DataProvider>
                            <InitialAdvertCreator>
                                <Switch>
                                    <Route path={routes.conversations} exact component={Conversations}/>
                                    <Route path={routes.catalogue} exact component={Catalogue}/>
                                    <Route path={routes.login} exact component={Login}/>
                                    <Route path={routes.registration} exact component={Registration}/>
                                    <Route path={routes.forgottenPassword} exact component={ForgottenPassword}/>
                                    <Route path={routes.settings} exact component={Settings}/>
                                    <Route path={routes.statistics} exact component={Statistics}/>
                                    <Route path={routes.prerecordedMessages} exact component={PrerecordedMessages}/>
                                    <Route path="/" exact
                                           render={() => (<Redirect to={generateUrl(routes.conversations)}/>)}/>
                                    <Route path="/" component={PageNotFound}/>
                                </Switch>
                            </InitialAdvertCreator>
                        </DataProvider>
                    </Router>
                </TokenRefresher>
            </TimeProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js